interface Sections {
  name: string
  data: any
}

export function sliceSections(
  index: number,
  campaignPage: boolean,
  sections: Sections[] | undefined
) {
  return campaignPage
    ? sections?.slice(index, sections?.length)
    : sections?.slice(0, index + 1)
}
